/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Coinvestment_Outreachemail2Inputs */

const en_settings_coinvestment_outreachemail2 = /** @type {(inputs: Settings_Coinvestment_Outreachemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outreach email`)
};

/**
* | output |
* | --- |
* | "Outreach email" |
*
* @param {Settings_Coinvestment_Outreachemail2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_coinvestment_outreachemail2 = /** @type {((inputs?: Settings_Coinvestment_Outreachemail2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Coinvestment_Outreachemail2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_coinvestment_outreachemail2(inputs)
});
export { settings_coinvestment_outreachemail2 as "settings_coInvestment_outreachEmail" }